import React from "react";
import { Box, Spacer, Stack, Typography } from "digiwash-components";
import CustomIcon from "../CustomIcon";
import { formatPrice } from "digiwash-core";

interface PropsType {
  text: string;
  sub?: string;
  total?: number;
}

function NotifyBox(props: PropsType) {
  return (
    <Box bg="yellow.light200" p="m" br="xm">
      <Stack distribution="space-between">
        <Stack>
          <CustomIcon icon="star" width={16} height={16} />
          <Spacer size="s" />
          <Typography fs="s" color="common.black">
            {props.text}
          </Typography>
        </Stack>
        {props.total ? (
          <Stack>
            {props.sub ? (
              <>
                <Typography fs="s" color="gray.dark200">
                  در مجموع:
                </Typography>
                <Spacer size="s" />
              </>
            ) : (
              <></>
            )}
            <Typography ff="mainBold" fs="s" color="gray.dark200">
              {formatPrice(props.total)} تومان
            </Typography>
          </Stack>
        ) : (
          <></>
        )}
      </Stack>
    </Box>
  );
}

export default NotifyBox;
